import { Record, Static, String } from "runtypes";
import { OrderTransactionId } from "./OrderTransactionId";

export const OrderTransaction = Record({
  orderTransactionId: OrderTransactionId,
  gateway: String.optional()
});

export type OrderTransaction = Static<typeof OrderTransaction>;
